export default "__VITE_ASSET__db5365c4__"